<div class="overlay" *ngIf="loading || !measuring">
  <mat-spinner class="my-black-spinner"></mat-spinner>
</div>

<!-- Hidden measurement container — renders items once for height measurement -->
<div class="measure-host" *ngIf="loading" #measure>
  <ng-container *ngFor="let it of measureItems; trackBy: trackByItem; let i = index">
    <div [attr.data-mi]="i">
      <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ $implicit: it }"></ng-container>
    </div>
  </ng-container>
</div>

<div class="report-wrapper" id="print-area" *ngIf="!loading">

  <div class="page-sheet"
       *ngFor="let page of pages; let i = index; trackBy: trackByPage"
       [class.last-page]="i === pages.length - 1 && pages.length > 1">

    <!-- Banners only on first page -->
    <ng-container *ngIf="page.isFirst">
      <div class="banner-container">
        <img src="assets/images/banner.png" class="banner-image">
      </div>
      <div class="headers">
        <div class="header1">{{ header1 }}</div>
        <div class="header2">
          {{ header2 }}
          <a target="_blank" [href]="header3">{{ header3 }}</a>
          {{ header4 }}
        </div>
        <div class="header3">{{ header5 }}</div>
      </div>
      <div class="lower_banner-container">
        <img src="assets/images/banner_below.png" class="banner-image">
      </div>
      <div class="no-print" style="text-align:right; margin: 8px 0;">
        <button (click)="print()">Print</button>
      </div>
    </ng-container>

    <div class="multi-col">
      <ng-container *ngFor="let it of page.items; trackBy: trackByItem">
        <ng-container [ngTemplateOutlet]="itemTpl" [ngTemplateOutletContext]="{ $implicit: it }"></ng-container>
      </ng-container>
    </div>

  </div>
</div>

<!-- ===== Reusable item template ===== -->
<ng-template #itemTpl let-it>
  <ng-container [ngSwitch]="it.type">

    <ng-container *ngSwitchCase="'division-header'">
      <div class="division-header" [style.background]="it.div.header.color">
        <div class="division-title">{{ it.div.header.name || 'Unnamed Division' }}</div>
      </div>

      <a class="division-meta"
         target="_blank"
         [href]="it.div.header.mapUrl || '#'">
        <div class="meta-item" *ngIf="it.div.header.fax">Fax: {{ it.div.header.fax }}</div>
        <div class="meta-item" *ngIf="it.div.header.phone">Phone: {{ it.div.header.phone }}</div>
        <div class="meta-item" *ngIf="it.div.header.deptAddress">Addr: {{ it.div.header.deptAddress }}</div>
      </a>
    </ng-container>

    <div *ngSwitchCase="'section-header'" class="section-header" [style.background]="it.sec.header.color">
      {{ it.sec.header.name || 'Unnamed Section' }} {{ it.sec.header.sectionNote }}
      <hr>
    </div>

    <div *ngSwitchCase="'employee'" class="employee-row"
         [style.background]="(it.emp.employeeColor && it.emp.employeeColor.trim()) ? it.emp.employeeColor : it.sec.header.employeeColor">
      <div class="employee-name" [class.employee-bold]="it.emp.bold">
        <span *ngIf="getUserStatusId(it.emp) === 2">*</span>
        {{ it.emp.lastName | uppercase }}, {{ it.emp.firstName }}
      </div>
      <div class="employee-phones" [class.employee-bold]="it.emp.bold">
        <span class="phone-chip" *ngFor="let p of it.emp.phoneList; trackBy: trackByPhone">
          <span class="phone-label" >{{ p.deviceType === 1 ? 'O' : 'M' }}</span>{{ p.phoneNo }}
        </span>
      </div>
    </div>

   

  </ng-container>
</ng-template>


<section class="prd-view" *ngIf="measuring">
  <div class="prd-masonry" *ngIf="sortedRecords.length; else emptyState">
    <div *ngFor="let r of sortedRecords"
         class="prd-office-card"
         [class.prd-office-card--emergency]="r.officeType === 'Emergency'"
         [class.prd-office-card--nonemergency]="r.officeType === 'Non-Emergency'"
         [class.prd-office-card--none]="r.officeType === 'None'"
         [style.background]="r.fillColor"
         [style.border-color]="r.borderColor">

      <!-- OfficeName as the prominent header -->
      <div class="prd-office-card__header"
           [style.border-bottom-color]="r.borderColor">
        <span class="prd-office-card__name">{{ r.officeName }}</span>
      </div>

      <!-- Phone -->
      <div class="prd-office-card__phone">
        📞 {{ r.phoneNo }}
      </div>

      <div class="prd-office-card__type-pill">
        <span *ngIf="r.officeType === 'Emergency'">🚨</span>
        <span *ngIf="r.officeType === 'Non-Emergency'">🏢</span>

        <span *ngIf="r.officeType === 'Emergency' || r.officeType === 'Non-Emergency'"
              [ngClass]="r.officeType === 'Emergency' 
                        ? 'prd-office-card--emergency' 
                        : 'prd-office-card--nonemergency'">
          {{ r.officeType }}
        </span>
      </div>

    </div>
  </div>

  <ng-template #emptyState>
    <div class="prd-empty prd-empty--center">No office records available</div>
  </ng-template>

</section>

<section class="pdl-view" *ngIf="measuring">

  <div class="pdl-grid"
       *ngIf="col1Records.length || col2Records.length || col3Records.length; else pdlEmpty">

    <!-- Column 1: #f83444 + pinned header -->
    <div class="pdl-col">
      <ng-container *ngFor="let r of col1Records; trackBy: trackByOffice">
        <ng-container *ngTemplateOutlet="pdlCardTpl; context: { $implicit: r }"></ng-container>
      </ng-container>
    </div>

    <!-- Column 2: #ffff46 -->
    <div class="pdl-col">
      <ng-container *ngFor="let r of col2Records; trackBy: trackByOffice">
        <ng-container *ngTemplateOutlet="pdlCardTpl; context: { $implicit: r }"></ng-container>
      </ng-container>
    </div>

    <!-- Column 3: everything else -->
    <div class="pdl-col">
      <ng-container *ngFor="let r of col3Records; trackBy: trackByOffice">
        <ng-container *ngTemplateOutlet="pdlCardTpl; context: { $implicit: r }"></ng-container>
      </ng-container>
    </div>

  </div>

  <ng-template #pdlEmpty>
    <div class="pdl-empty pdl-empty--center">No office records available</div>
  </ng-template>
</section>

<!-- Reusable card template (same as before) -->
<ng-template #pdlCardTpl let-r>
  <div class="pdl-card"
       [class.pdl-card--header]="r.isHeader"
       [style.background]="r.fillColor"
       [style.border-color]="r.borderColor"
       [style.color]="r.fontColor">

    <div class="pdl-card__header" [style.color]="r.fontColor">
      <span class="pdl-card__name">{{ r.officeName }}</span>
    </div>

    <div class="pdl-card__bar" [style.background]="r.borderColor"></div>

    <div class="pdl-desk-list" *ngIf="!r.isHeader">
      <div class="pdl-desk-row" *ngFor="let d of r.phoneDesks">
        <div class="pdl-desk-location">{{ d.deskLocation }}</div>
        <div class="pdl-desk-phone">
          <span class="pdl-phone-chip">
            <span class="pdl-phone-label">O</span>{{ d.phoneNo }}
          </span>
        </div>
      </div>

      <div class="pdl-desk-empty" *ngIf="!r.phoneDesks?.length">
        No phone desks
      </div>
    </div>
  </div>
</ng-template>

 <div style="height: 40px;"></div>